
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'Loader',

  props: {
    isLoading: {
      type: Boolean,
      default: true
    },

    loadingText: {
      type: String,
      default: null
    },

    iconOnly: {
      type: Boolean,
      default: false
    },

    isDog: {
      type: Boolean,
      default: false
    },

    showLongLoadingText: {
      type: Boolean,
      default: true
    },

    longLoadingTextClass: {
      type: String,
      default: null
    },

    loadingWrapperClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      timeStart: 0,
      timer: null,
      longLoadingText: null,
      isConsideredTimeout: false,
      faSpinnerThird
    }
  },

  computed: {
    compLoadingText() {
      return this.loadingText || `${this.$t('loading')}...`
    }
  },

  watch: {
    isLoading(loading) {
      if (loading) {
        this.startSlowLoadingTimer()
      } else {
        this.stopSlowLoadingTimer()
      }
    }
  },

  mounted() {
    if (this.isLoading) {
      this.startSlowLoadingTimer()
    }
  },

  destroyed() {
    this.stopSlowLoadingTimer()
  },

  methods: {
    startSlowLoadingTimer() {
      if (!this.timer) {
        this.timeStart = this.$date()

        this.timer = setInterval(() => {
          const timeNow = this.$date()

          const secondsTimeDifference = timeNow.diff(this.timeStart, 'second')

          if (secondsTimeDifference > 6) {
            this.longLoadingText = this.$t('stillLoading')
          }

          if (secondsTimeDifference > 15) {
            this.longLoadingText =
              'Internet connectivity issues? Virgin Media customers will need to switch to a mobile network'
          }

          // If their internet is offline we don't want them contacting us
          if (secondsTimeDifference > 25 && this.$app.isOnline) {
            this.longLoadingText = this.$t('takingTooLongTryReloading')
            this.isConsideredTimeout = true
          }
        }, 1000)
      }
    },

    stopSlowLoadingTimer() {
      clearInterval(this.timer)
      this.longLoadingText = null
    }
  }
}
